import { render } from "./AlertModal.vue?vue&type=template&id=760fa6ae"
import script from "./AlertModal.vue?vue&type=script&lang=js"
export * from "./AlertModal.vue?vue&type=script&lang=js"
script.render = render

export default script